import { lazy } from 'react';

const page = lazy(() => import(/* webpackChunkName: 'MeetingOverviewPage' */ '.'));

export default page;
